import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import RecordBetsReportUsers from 'views/reports/betsReport/recordTableTransReport'; // Importing a specific view for user records
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record bets report view.
 * @extends JetView
 */
export default class recordBetsReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme from app configuration

        // Toolbar configuration with pagination and selection options
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting number of items per page
                    options: ['10', '20', '50', '100'], // Options for items per page
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for changing items per page
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size based on selection
                            $$('datatable').refresh(); // Refresh the datatable to reflect changes
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerAA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default size from development config
                },
            ],
        };

        // Left side layout configuration
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the title
                    css: theme, // Apply current theme
                    elements: [
                        {
                            view: 'label', // Label for the title
                            label: _('Historial de Transacciones'), // Translated title
                        },
                    ],
                },
                RecordBetsReportUsers, // Including the imported RecordBetsReportUsers view
                toolbar, // Adding the toolbar to the layout
            ],
        };

        // Returning the main layout configuration
        return {
            height: screen.width < 820 ? 430 : 300, // Responsive height based on screen width
            type: 'wide', // Layout type
            cols: [left], // Columns configuration
        };
    }
}

// FILE DOCUMENTED
